<template>
  <!-- create a login page using bootstrap-->
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h1>{{ $t("gpool.form_login") }}</h1>
            <form @submit.prevent="login(session)">
              <div class="mb-3">
                <label
                  class="form-label"
                  for="username"
                  >{{ $t("gpool.form_username") }}</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="username"
                  required
                  :disabled="loading"
                  v-model="session.username"
                />
              </div>
              <div class="mb-3">
                <label
                  class="form-label"
                  for="password"
                  >{{ $t("gpool.form_password") }}</label
                >
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  required
                  :disabled="loading"
                  v-model="session.password"
                />
              </div>
              <button
                :disabled="loading"
                type="submit"
                class="btn btn-primary"
              >
                <span v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
                <span v-else>
                  {{ $t("gpool.form_login") }}
                </span>
              </button>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <!-- add button group to select language -->
            <div
              class="btn-group"
              role="group"
            >
              <button
                type="button"
                class="btn"
                :class="{
                  'btn-primary': active_lang == lang.code,
                  'btn-outline-primary': active_lang != lang.code
                }"
                v-for="lang in langs"
                @click="changeLanguage(lang.code)"
              >
                {{ lang.name }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import langs from "../data/langs";
export default {
  name: "Login",
  computed: {
    ...mapState(["login_loading"]),
    loading() {
      return this.login_loading;
    },
    active_lang() {
      return this.$i18n.locale;
    }
  },
  methods: {
    ...mapActions(["login"]),
    ...mapActions("auth", ["changeLanguage"])
  },
  data() {
    return {
      langs,
      session: {
        username: "",
        password: ""
      }
    };
  }
};
</script>

<style>
.card {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue